import { type FC, type ReactNode } from 'react';

import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import * as Sentry from '@sentry/react';

import { isSentryEnabled } from '../../configs/sentry';

interface ErrorBoundaryProps {
  children: ReactNode;
}

const FallbackComponent = () => <p>Something went wrong:</p>;

const ErrorBoundary: FC<ErrorBoundaryProps> = ({ children }) => {
  if (isSentryEnabled) {
    return <Sentry.ErrorBoundary fallback={<FallbackComponent />}>{children}</Sentry.ErrorBoundary>;
  } else {
    return <ReactErrorBoundary fallback={<FallbackComponent />}>{children}</ReactErrorBoundary>;
  }
};

export default ErrorBoundary;
